import React, { useEffect } from 'react';
import { useRef } from 'react';
import './popup.css';

const Popup = ({ isOpen, onClose, children }) => {
    const dialogRef = useRef();
    useEffect(() => {
        if (isOpen) {
            dialogRef.current.showModal();
        } else {
            dialogRef.current.close();
        }
    }, [isOpen]);
    return (
        <dialog
            ref={dialogRef}
            onCancel={onClose}
            onClick={(e) => {
                if (e.target === dialogRef.current) onClose();
            }}
        >
            {children}
        </dialog>
    );
};

export default Popup;
